export function createRoutePath(paths: string[] | string) {
  if (paths instanceof Array) {
    return "/" + paths.filter((path) => path != "").join("/");
  }
  return "/" + paths;
}
